import { useQuery } from '@tanstack/react-query';
import { httpService } from '../../../utils/apiService';

export const useGetAuditLogs = ({ params, options = {} }) => {
  return useQuery({
    queryKey: ['AuditLogs', params],
    queryFn: async () => {
      const queryParams = new URLSearchParams();

      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          queryParams.append(key, value);
        }
      });

      const response = await httpService.post(
        `action-logs/list?${queryParams.toString()}`,
        params
      );
      return response?.data?.data;
    },
    refetchOnWindowFocus: false,
    ...options,
  });
};
